import React from 'react';
import { IonList } from '@ionic/react';
import EmptyList from 'components/empty/EmptyList';
import EmptyBox from 'assets/illustrations/empty-box.svg';
import LoadingListSkeletalLoader from 'core/layout/loading-ion-list/LoadingListSkeletalLoader';

type LoadingIonListProps = {
  label: string;
  description?: string;
  items?: any[] | null;
  loading: boolean;
  emptyImage?: string;
  className?: string;
};

const LoadingIonList: React.FC<LoadingIonListProps> = ({
  loading,
  label = 'Items',
  description,
  items,
  emptyImage = EmptyBox,
  className = '',
  children,
  ...rest
}) => {
  return loading ? (
    <div id="loading-ion-list">
      <LoadingListSkeletalLoader className={className} />
    </div>
  ) : !!items && items.length ? (
    <IonList {...rest} className={className}>
      {children}
    </IonList>
  ) : (
    <EmptyList image={emptyImage} label={label} description={description} />
  );
};

export default LoadingIonList;
